import React from 'react';
import { useScopedI18n } from '@locales/client';

import { H1_HeadingBoldH4 } from '@/shared/ui/typography2';
import { HeaderBox } from './styles';

export const BonusHeader = () => {
  const t = useScopedI18n('bonus');

  return (
    <HeaderBox>
      <H1_HeadingBoldH4>{t('title')}</H1_HeadingBoldH4>
    </HeaderBox>
  );
};
